<template>
    <div class="pop rd-dialog rd-confirm" :class="classObj">
        <van-popup v-model="show" @click-overlay="close">
            <div class="content">
                <div class="title">{{ $t('playGameByDeposit.title') }}</div>
                <div class="desc">{{ $t('playGameByDeposit.desc') }}</div>
                <div class="actions">
                    <div class="btn btn--primary" @click="toDeposit">{{ $t('playGameByDeposit.activateNow') }}</div>
                    <div class="btn btn--ghost" @click="close">{{ $t('playGameByDeposit.reject') }}</div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    computed: {
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile'
            }
        },
        show: {
            get() {
                return this.$store.getters.isShowPlayGamePopup
            },
            set(val) {
                return val
            }
        }
    },
    methods: {
        close() {
            this.$store.dispatch('system/setIsShowPlayGamePopup', false)
        },
        toDeposit() {
            if (this.$route.path.indexOf('/wallet') !== -1) {
                return
            }
            const params = { type: 'deposit' }
            this.onNavTo({ url: '/wallet', type: 'get', params })
            this.close()
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

.pop {
    text-align: left;
    ::v-deep .van-popup {
        background: transparent;
        width: 94%;
        max-width: 430px;
    }
    &.mobile {
        .content {
            .body {
                .desc_txt {
                    &>div:first-child {
                        font-size: .45rem;
                        padding: 0;
                    }
                }
            }
        }
    }

    .content {
        width: 100%;
        height: 100%;
        border-radius: .28rem;
        box-sizing: border-box;
        position: relative;
        border: .01rem solid transparent;
        background-image:
            linear-gradient(to right, var(--theme-popup-box-bg), var(--theme-popup-box-bg)),
            linear-gradient(90deg, var(--theme-popup-box-border), var(--theme-popup-box-border));
        background-origin: border-box;
        background-clip: content-box, border-box;
        box-shadow: var(--theme-popup-box-shadow);

        .title {
            font-size: .36rem;
            line-height: .42rem;
            color: $font-color;
            font-weight: 700;
            text-align: center;
            margin-top: .5rem;
            padding: 0 .38rem;
        }

        .desc {
            margin-top: .24rem;
            color: var(--theme-sidebar-item-text);
            font-size: .26rem;
            line-height: .38rem;
            text-align: center;
            padding: 0 .38rem;
        }

        .actions {
            margin-top: .48rem;
            display: flex;
            flex-direction: column;
            gap: .28rem;
            padding-bottom: .5rem;
        }

        .btn {
            height: .82rem;
            border-radius: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: .28rem;
            font-weight: 700;
            cursor: pointer;
            user-select: none;
            margin: 0 .38rem;
        }

        .btn--primary {
            color: var(--theme-gold-text);
            background: var(--theme-gold-bg);
        }

        .btn--ghost {
            border: .01rem solid transparent;
            background-image:
                linear-gradient(to right, var(--theme-popup-box-bg), var(--theme-popup-box-bg)),
                linear-gradient(90deg, var(--theme-popup-box-border), var(--theme-popup-box-border));
            background-origin: border-box;
            background-clip: content-box, border-box;
            box-shadow: var(--theme-popup-box-shadow);
        }
    }
}
</style>
